const DotsVertical = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.84961 14.6489C9.12575 14.6489 9.34961 14.4251 9.34961 14.1489C9.34961 13.8728 9.12575 13.6489 8.84961 13.6489C8.57347 13.6489 8.34961 13.8728 8.34961 14.1489C8.34961 14.4251 8.57347 14.6489 8.84961 14.6489Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.84961 3.64893C9.12575 3.64893 9.34961 3.42507 9.34961 3.14893C9.34961 2.87278 9.12575 2.64893 8.84961 2.64893C8.57347 2.64893 8.34961 2.87278 8.34961 3.14893C8.34961 3.42507 8.57347 3.64893 8.84961 3.64893Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.84961 9.14893C9.12575 9.14893 9.34961 8.92507 9.34961 8.64893C9.34961 8.37278 9.12575 8.14893 8.84961 8.14893C8.57347 8.14893 8.34961 8.37278 8.34961 8.64893C8.34961 8.92507 8.57347 9.14893 8.84961 9.14893Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DotsVertical
